export default class Progress {
    [x: string]: any;

    constructor() {
        this.finish = false;
    }

    start() {
        this.finish = false;
    }

    setFinish(state) {
        this.finish = state;
    }

    getFinish() {
        return this.finish;
    }

}
